import { createFileRoute } from "@tanstack/react-router";
import { Dashboard } from "#app/widgets/dashboards/dashboard";
import { WidgetsGate } from "#app/widgets/dashboards/widgets-gate";
import { useWorkflowId } from "#app/lib/hooks/use-workflow-id";

/**
 * `/workflow/$workflowId/dashboard` — the workflow dashboard, scoped to one
 * workflow. Feature-flagged behind WIDGETS; navigating here with the flag off
 * redirects to the board (the tab is hidden in that case anyway). Flags
 * resolve async, so hold on a spinner until `ready` — deciding early would
 * bounce flag-on users to the board on a fresh load.
 */
function WorkflowDashboardRoute() {
  const { workspace } = Route.useParams();
  const workflowId = useWorkflowId();
  if (!workflowId) return null;
  return (
    <WidgetsGate redirectTo={`/${workspace}/workflow/${workflowId}/board`}>
      <Dashboard scope={{ kind: "workflow", workflowId }} />
    </WidgetsGate>
  );
}

export const Route = createFileRoute(
  "/(app)/$workspace/workflow/$workflowId/dashboard",
)({
  component: WorkflowDashboardRoute,
});
